module.exports = __webpack_public_path__ + "img/onboarding-completed-overview.c52ea17a.png";